import { Box, Button, Text } from '@chakra-ui/react';
import React from 'react';
import AuthModal, { AuthModalScreen } from '../../Auth/Modal';
import { sendTrackingEvent } from '../../../utils/gtm';

const Varient1 = ({ title, text, link, btnText }: any) => {
	const [isAuthOpen, setIsAuthOpen] = React.useState(false);
	return (
		<Box bg="#5968D8">
			<Box textAlign="center" color="white" px="20px" py={{ base: '31px', md: '49px' }}>
				<Text textStyle={{ base: 'h3', md: 'h2' }} mb={{ base: '12px', md: '24px' }}>
					{title}
				</Text>
				<Text textStyle="body1-md" mb="24px" maxW="1097px" mx="auto" color={{ base: '#F3F2F2', md: '#D9D9D9' }}>
					{text}
				</Text>
				<Button
					w="full"
					maxW="385px"
					onClick={() => {
						sendTrackingEvent({
							event: 'cn_start_learnigng4',
							eventLabel: window.location.href,
						});
						window.location.href = '/sign-in';
					}}
					bg="#F2F6FF"
					color="#4358F6"
					textStyle="btn-lg"
					size="lg"
				>
					{btnText}
				</Button>
			</Box>
			{/* <AuthModal
				onSuccess={() => {
					window.location.href = '/dashboard';
				}}
				defaultScreen={AuthModalScreen.LOGIN}
				isOpen={isAuthOpen}
				onClose={() => {
					setIsAuthOpen(false);
				}}
			/> */}
		</Box>
	);
};

export default Varient1;
